/**
 * This module will load in a piece of DOM and swap it with the current DOM given a selector.
 *
 * @param {string} url - The target URL of the DOM to swap in
 * @param {string} selector - This serves as both the source and target selector for the piece of DOM
 * @return {Promise} A promise that will resolve when it's done loading / swapping.
 */

function swapDOM(url, selector) {
	return new Promise(resolve => {
		let req = new XMLHttpRequest();
		req.onload = function () {
			if (typeof selector === "undefined") return false;
			const contentToRemove = document.querySelector(selector);
			const titleToReplace = document.querySelector('title');
			const target = contentToRemove.parentElement;
			contentToRemove.remove();
			const wrapperEl = document.createElement('div');
			wrapperEl.innerHTML = req.response;
			const newContent = wrapperEl.querySelector(selector);
			titleToReplace.innerHTML = wrapperEl.querySelector('title').innerHTML;
			target.appendChild(newContent);
			resolve();
		};
		req.open('get', url, true);
		req.send();
	});
}

export default swapDOM;
